import React, { useState, useEffect } from "react";

export default function AddProjectForm({ onAddProject, projectData }) {
  const [projectName, setProjectName] = useState("");
  const [subject, setSubject] = useState("");

  useEffect(() => {
    if (projectData && projectData.length > 0) {
      let parsedDetails = {};
      try {
        parsedDetails = JSON.parse(projectData[0].details || "{}");
      } catch (err) {
        console.error("Invalid JSON in details:", err);
      }

      setProjectName(parsedDetails.name || "");
      setSubject(parsedDetails.subject || "");
    }
  }, [projectData]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!projectName.trim() || !subject.trim()) {
      alert("Please fill all fields");
      return;
    }

    onAddProject({
      name: projectName,
      subject: subject,
    });

    // Reset only if adding new
    if (!projectData || projectData.length === 0) {
      setProjectName("");
      setSubject("");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        maxWidth: "400px",
        margin: "0 auto",
        background: "#f9f9f9",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <div style={{ marginBottom: "15px" }}>
        <label
          style={{
            display: "block",
            marginBottom: "5px",
            fontWeight: "bold",
            color: "#444",
          }}
        >
          Project Name
        </label>
        <input
          type="text"
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
          style={{
            padding: "10px",
            width: "100%",
            borderRadius: "4px",
            border: "1px solid #ccc",
            outline: "none",
          }}
        />
      </div>

      <div style={{ marginBottom: "15px" }}>
        <label
          style={{
            display: "block",
            marginBottom: "5px",
            fontWeight: "bold",
            color: "#444",
          }}
        >
          Description
        </label>
        <input
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          style={{
            padding: "10px",
            width: "100%",
            borderRadius: "4px",
            border: "1px solid #ccc",
            outline: "none",
          }}
        />
      </div>

      <button
        type="submit"
        style={{
          display: "block",
          margin: "20px auto 0",
          width: "150px",
          padding: "10px",
          background:
            projectData && projectData.length > 0 ? "#28a745" : "#007bff",
          color: "white",
          border: "none",
          borderRadius: "4px",
          fontSize: "16px",
          cursor: "pointer",
        }}
      >
        {projectData && projectData.length > 0 ? "Update" : "Submit"}
      </button>
    </form>
  );
}
